import React, { Component } from 'react';
import { Modal, Button, Row } from 'antd/lib';
import _ from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';

class ModalVerDepositoContravencion extends Component {
  render() {
    let deposito = this.props.deposito;

    if (deposito._id) {
      return (
        <div>
          <Modal
            title={'Detalles del Deposito'}
            visible={this.props.mostrarModalVerDepositoContravencion}
            onCancel={this.props.ocultarModalVerDepositoContravencion}
            width={500}
            footer={[
              <Button
                key="back"
                type="primary"
                onClick={this.props.ocultarModalVerDepositoContravencion}
              >
                Volver
              </Button>,
            ]}
          >
            <>
              <Row>
                <h3> Organismo: {deposito.organismo.nombre} </h3>
              </Row>
              {deposito.importe && (
                <Row>
                  <h3>
                    Monto Depositado:
                    {deposito.importe.toLocaleString('es-AR', {
                      style: 'currency',
                      currency: 'ARS',
                    })}
                  </h3>
                </Row>
              )}
              {deposito.fechaDeposito && (
                <Row>
                  <h3>
                    Fecha del deposito:
                    {moment(deposito.fechaDeposito).format('DD/MM/YYYY')}
                  </h3>
                </Row>
              )}
              {!deposito.fechaCreacion && (
                <Row>
                  <h3>
                    Fecha de Creacion:
                    {moment(deposito.fechaCreacion).format('DD/MM/YYYY')}
                  </h3>
                </Row>
              )}
              {deposito.tipo && (
                <Row>
                  <h3>Tipo de Pago: {deposito.tipo.toUpperCase()}</h3>
                </Row>
              )}

              {deposito.tipo === 'transferencia' && (
                <Row>
                  <h3> Nombre Banco: {deposito.nombreBancoTransferencia} </h3>
                </Row>
              )}

              {deposito.tipo === 'deposito' && (
                <Row>
                  <h3> Sucursal: {deposito.sucursal.nombre} </h3>
                </Row>
              )}

              {deposito.numBoletaDeposito && (
                <Row>
                  <h3> N° de Referencia: {deposito.numBoletaDeposito} </h3>
                </Row>
              )}

              <h4> Recibos Pagados: </h4>
              {_.map(deposito.recibos, recibo => (
                <p key={recibo._id}>
                  {recibo.nombre}:
                  {recibo.contraventor
                    ? recibo.contraventor.sancion.monto.toLocaleString(
                        'es-AR',
                        {
                          style: 'currency',
                          currency: 'ARS',
                        }
                      )
                    : 'SIN DATOS'}
                  .
                </p>
              ))}
            </>
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withApollo(ModalVerDepositoContravencion);
